'use client';
import { createContext } from 'react';

// `true` when an ancestor <MapView> is currently in 'full' mode (i.e. covering
// the viewport). Descendants that render their own inline minimap (today:
// PostFactiiisCount inside MapSidebar's PinBubble → PostItem) read this to
// suppress that redundant preview.
//
// Default false: outside a <MapView> subtree, no suppression. Provider scope
// keeps the signal tree-local, so a fullscreen-expanded post minimap only
// suppresses minimaps in its OWN sidebar, not unrelated PostFactiiisCount
// elsewhere on the page (which is hidden by the browser fullscreen anyway).
export const MapOverlayContext = createContext<boolean>(false);
